let ignoreTypes = {
    м: true,
    тер: true,
    мост: true,
};

export default ignoreTypes;
